<template>
  <div class="index">
    <div class="center">
      <div class="top df">
        <div class="img1" @click="tolink">
          <img src="../img/logo.png" alt="" />
        </div>

        <div class="df">
          <div class="img2"><img src="../img/time.png" alt="" /></div>
          <div style="width: 280px">
            {{ $t("index.time") }} :{{ currentTime }}
          </div>

          <div class="en" @mouseenter="enter()" @mouseleave="leave()">
            {{ $t("index.languages") }}
          </div>
          <div
            class="cn"
            :class="encn ? suo : cn"
            @mouseenter="enter()"
            @mouseleave="leave()"
          >
            <div class="df" @click="enlanguage">
              <span></span>
              <div class="item">{{ $t("index.en") }}</div>
            </div>
            <div class="df" @click="cnlanguage">
              <span></span>
              <div class="item" style="border: 0">{{ $t("index.cn") }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner">
        <div class="title" v-if="!lashow">
          <img src="../img/titch.png" alt="" />
        </div>
        <div class="title" v-if="lashow">
          <img src="../img/titen.png" alt="" />
        </div>
        <div class="jiaoyibnt" v-if="!lashow">
          <img src="../img/bnt.png" alt="" />
        </div>
        <div class="jiaoyibnt" v-if="lashow">
          <img src="../img/bnten.png" alt="" />
        </div>
      </div>
    </div>
    <div class="boxtitle df">
      <div
        class="titles df"
        @click="tabnav = 1"
        :class="tabnav == 1 ? '' : tielesclick"
      >
        <div class="dian"></div>
        <div>{{ $t("index.jiao") }}</div>
        <div class="dian"></div>
      </div>
      <div
        class="titles df"
        :class="tabnav == 2 ? '' : tielesclick"
        @click="tabnav = 2"
      >
        <div class="dian"></div>
        <div>{{ $t("index.coll") }}</div>
        <div class="dian"></div>
      </div>
      <div
        class="titles df"
        @click="tabnav = 3"
        :class="tabnav == 3 ? '' : tielesclick"
      >
        <div class="dian"></div>
        <div>{{ $t("index.coll5") }}</div>
        <div class="dian"></div>
      </div>
    </div>

    <!-- 表格1 -->
    <div class="table" v-show="tabnav == 1">
      <div>
        <el-table
          :data="tableData"
          stripe
          :header-cell-style="{ background: '#0F4FE3', color: '#fff' }"
          @row-click="handdle"
          style="width: 100%"
        >
          <el-table-column prop="date" align="center">
            <template slot="header">
              <div>{{ $t("index.tras") }}</div>
            </template>
            <template slot-scope="scope">
              <div class="now" style="margin-left: 10px">
                {{ scope.row.id }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="block_num" align="center">
            <template slot="header">
              <div>{{ $t("index.block") }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="act_name" align="center">
            <template slot="header">
              <div class="send">{{ $t("index.acco") }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="act_account" align="center">
            <template slot="header">
              <div class="send">{{ $t("index.acti") }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="timestamp" align="center" width="220">
            <template slot="header">
              <div>{{ $t("index.gmt") }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 表格2 -->

    <div class="table" v-show="tabnav == 2">
      <div>
        <el-table
          :data="onelist"
          stripe
          :header-cell-style="{ background: '#0F4FE3', color: '#fff' }"
          @row-click="oneclick"
        >
          <el-table-column align="center">
            <template slot="header">
              <div>{{ $t("index.tras") }}</div>
            </template>
            <template slot-scope="scope">
              <div class="now" style="margin-left: 10px">
                {{ scope.row.eosData.id }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="block_num" align="center">
            <template slot="header">
              <div>{{ $t("index.block") }}</div>
            </template>
            <template slot-scope="scope">
              <div>{{ scope.row.eosData.block_num }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="collectTime" align="center">
            <template slot="header">
              <div>{{ $t("index.cotime") }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 表格 3-->

    <div class="table" v-show="tabnav == 3">
      <div>
        <el-table
          :data="twolist"
          stripe
          :header-cell-style="{ background: '#0F4FE3', color: '#fff' }"
          @row-click="twoclick"
        >
          <el-table-column align="center">
            <template slot="header">
              <div>{{ $t("index.tras") }}</div>
            </template>
            <template slot-scope="scope">
              <div class="now" style="margin-left: 10px">
                {{ scope.row.eosData.id }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="block_num" align="center">
            <template slot="header">
              <div>{{ $t("index.block") }}</div>
            </template>
            <template slot-scope="scope">
              <div>{{ scope.row.eosData.block_num }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="collectTime" align="center">
            <template slot="header">
              <div>{{ $t("index.cotime") }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 底部 -->
    <div class="bom">
      <div>
        <div><img src="../img/xian.png" alt="" /></div>
        <div class="df cen" style="align-items: flex-start">
          <div class="logos df">
            <div class="img1"><img src="../img/bomlogo.png" alt="" /></div>
            <div class="eos df">
              {{ $t("index.zhuce") }}
              <div class="img2"><img src="../img/to.png" alt="" /></div>
            </div>
            <div class="df">
              <div class="img3"><img src="../img/twitter.png" alt="" /></div>
              <div class="img3"><img src="../img/in.png" alt="" /></div>
              <div class="img4"><img src="../img/Youtube.png" alt="" /></div>
            </div>
          </div>
          <div class="df item" style="flex-direction: column">
            <p @click="tolink">{{ $t("index.for") }}</p>
            <p @click="tolink">{{ $t("index.re") }}</p>
            <p @click="tolink">{{ $t("index.eosp") }}</p>
            <p @click="tolink">{{ $t("index.news") }}</p>
            <p @click="tolink">{{ $t("index.events") }}</p>
            <p @click="tolink">{{ $t("index.about") }}</p>
          </div>
          <div class="df item" style="flex-direction: column">
            <p @click="tolink">Block.one</p>
            <p @click="tolink">{{ $t("index.dev") }}</p>
            <p @click="tolink">GitHub</p>
            <p @click="tolink">{{ $t("index.stack") }}</p>
          </div>
          <div class="df item" style="flex-direction: column">
            <p @click="tolink">{{ $t("index.cont") }}</p>

            <p @click="tolink">{{ $t("index.faq") }}</p>

            <p @click="tolink">{{ $t("index.pri") }}</p>

            <p @click="tolink">{{ $t("index.terms") }}</p>
            <p @click="tolink">{{ $t("index.notic") }}</p>
            <p @click="tolink">{{ $t("index.feed") }}</p>
            <p @click="tolink">{{ $t("index.secur") }}</p>
          </div>
        </div>
        <div class="ban">&copy; 2021 Block.one All rights reserved.</div>
      </div>
    </div>
    <!-- 弹出层 -->
    <el-dialog :visible.sync="dialogVisible" width="45%" :show-close="false">
      <div class="tan" v-loading="loading">
        <div class="tantop df">
          <div class="tancss df" v-if="tabnav == 1">
            <div class="dians"></div>
            <div>{{ $t("index.jiao") }}</div>
            <div class="dians"></div>
          </div>
          <div class="tancss df" v-if="tabnav == 2">
            <div class="dians"></div>
            <div>{{ $t("index.coll") }}</div>
            <div class="dians"></div>
          </div>
          <div class="tancss df" v-if="tabnav == 3">
            <div class="dians"></div>
            <div>{{ $t("index.coll5") }}</div>
            <div class="dians"></div>
          </div>
          <div class="im2" @click="dialogVisible = false">
            <img v-if="!lashow" src="../img/Close.png" alt="" />
            <img v-if="lashow" src="../img/Closeen.png" alt="" />
          </div>
        </div>
        <div class="df" style="margin: 20px 0">
          <div>{{ $t("index.tras") }}</div>
          : <span class="pp">{{ tan.id }}</span>
        </div>
        <div class="df" style="justify-content: space-around">
          <div class="itemss">
            <div>{{ $t("index.block") }}:</div>
            <div>{{ tan.block_num }}</div>
            <div v-if="tabnav == 1">{{ $t("index.gmt") }}</div>

            <div v-if="tabnav != 1">{{ $t("index.cotime") }}:</div>
            <div v-if="tabnav == 1">{{ tan.timestamp }}</div>
            <div v-if="tabnav != 1">{{ datas }}</div>
          </div>
          <div class="itemss" v-if="tabnav == 1">
            <div>{{ $t("index.numb") }}</div>
            <div>{{ tan.action_ordinal }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 弹出层 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      timer: "", //定义一个定时器的变量
      currentTime: "", // 获取当前时间
      cn: "cn",
      suo: "suo",
      encn: true,
      dialogVisible: false,
      lashow: false,
      tan: "",
      tableData: [],
      websock: null,
      onelist: [],
      twolist: [],
      loading: false,
      tabnav: 1,
      tielesclick: "tielesclick",
      datas: "",
    };
  },
  created() {
    var vm = this;
    vm.timer = setInterval(() => {
      var y = new Date().getFullYear();
      var m = vm.appendZero(new Date().getMonth() + 1);
      var d = vm.appendZero(new Date().getDate());
      var ho = vm.appendZero(new Date().getHours());
      var mi = vm.appendZero(new Date().getMinutes());
      var se = vm.appendZero(new Date().getSeconds());
      //修改数据date
      this.currentTime =
        y + "-" + m + "-" + d + " " + "T" + ho + ":" + mi + ":" + se;
    }, 1000);
  },
  mounted() {
    this.initWebSocket();
    this.dayall();
    this.dayalls();
  },
  methods: {
    dayall() {
      this.$api.getData("open/eos/" + 50, {}, "POST").then((res) => {
        // console.log(res, "-");
        this.onelist = res;
      });
    },
    dayalls() {
      this.$api.getData("open/eos5/" + 50, {}, "POST").then((res) => {
        console.log(res, "2-");
        this.twolist = res;
      });
    },
    // 跳转外部链接
    tolink() {
      window.location.href = "https://testnet.eos.io/";
    },
    //时间过滤加0
    appendZero(obj) {
      if (obj < 10) {
        return "0" + obj;
      } else {
        return obj;
      }
    },
    // en
    enlanguage() {
      this.$i18n.locale = "en";
      this.lashow = true;
    },
    cnlanguage() {
      this.$i18n.locale = "zh";
      this.lashow = false;
    },

    enter() {
      console.log(1);
      this.encn = false;
    },
    leave() {
      console.log(2);
      this.encn = true;
    },
    // 点击弹窗
    handdle(row) {
      this.dialogVisible = true;
      this.loading = true;
      console.log(row);
      this.tan = row;
      let then = this;
      setTimeout(function () {
        // console.log(this.loading);
        then.loading = false;
      }, 700);
    },
    // 第二个表格弹窗
    oneclick(row) {
      console.log(row);

      this.dialogVisible = true;
      this.loading = true;
      this.tan = row.eosData;
      this.datas = row.collectTime;
      // console.log(this.tan);
      let then = this;
      setTimeout(function () {
        // console.log(this.loading);
        then.loading = false;
      }, 700);
    },
    twoclick(row) {
      console.log(row);
      this.loading = true;
      this.dialogVisible = true;
      this.tan = row.eosData;
      this.datas = row.collectTime;
      // console.log(this.tan);
      let then = this;
      setTimeout(function () {
        // console.log(this.loading);
        then.loading = false;
      }, 700);
    },
    threadPoxi() {
      // 实际调用的方法
      //参数
      const agentData = "mymessage";
      //若是ws开启状态
      if (this.websock.readyState === this.websock.OPEN) {
        this.websocketsend(agentData);
      }
      // 若是 正在开启状态，则等待300毫秒
      else if (this.websock.readyState === this.websock.CONNECTING) {
        let that = this; //保存当前对象this
        setTimeout(function () {
          that.websocketsend(agentData);
        }, 300);
      }
      // 若未开启 ，则等待500毫秒
      else {
        this.initWebSocket();
        let that = this; //保存当前对象this
        setTimeout(function () {
          that.websocketsend(agentData);
        }, 500);
      }
    },
    initWebSocket() {
      //初始化weosocket
      //ws地址
      const wsuri = "wss://eos-io.com/sub/eos/collect";
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    websocketonmessage(e) {
      //数据接收
      // console.log(e);
      // console.log( JSON.parse(e.data).content  );
      // const redata = JSON.parse(e);
      this.tableData = JSON.parse(e.data).content;
    },
    websocketsend(agentData) {
      //数据发送
      this.websock.send(agentData);
    },
    websocketclose(e) {
      //关闭
      console.log("connection closed (" + e.code + ")");
    },
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
  },
};
</script>


<style scoped lang='less'>
img {
  width: 100%;
  height: 100%;
}
.now {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; //显示行数
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.pp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /*想省略几行就写几*/
  -webkit-box-orient: vertical;
}
.df {
  display: flex;
  align-items: center;
}
.index {
  .center {
    background: #0f4fe3;
  }

  // 顶部
  .top {
    width: 60%;
    height: 100px;

    padding: 10px 200px;

    justify-content: space-between;
    color: #fff;
    margin: 0 auto;
    .to {
      justify-content: space-between;
    }
    .img1 {
      width: 195px;
      height: 80px;
      cursor: pointer;
    }
    .img2 {
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
    .en {
      width: 100px;
      padding: 5px 0;
      text-align: center;
      margin-left: 20px;

      border: 1px solid #fff;
      border-radius: 10px;
    }

    .cn {
      transform: scaleY(1);
      transform-origin: top;
      transition: transform 0.2s;
      padding: 3px 17px;
      background: #ffffff;
      color: #0f4fe3;
      position: relative;
      left: -98px;
      top: 37px;
      font-size: 13px;
      border-radius: 0 0 5px 5px;
      span {
        background: #0f4fe3;
        height: 10px;
        width: 2.5px;
      }
      .item {
        width: 30px;
        padding: 0 15px;
        border-bottom: 2px solid #0f4fe3;
      }
    }
    .suo {
      transform: scaleY(0);
      transform-origin: top;
    }
  }
  //banner

  .banner {
    border-top: 2px solid #fff;
    background-image: url("../img/banner.png");
    // width: 100%;
    height: 500px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    .jiaoyibnt {
      width: 350px;
      height: 107px;
      position: absolute;
      bottom: 25px;
      left: 41%;
    }
    .title {
      width: 450px;
      position: relative;
      left: 37%;
      bottom: -180px;
    }
  }

  .titles {
    width: 300px;
    height: 69px;
    border-radius: 15px;
    background: #0f4fe3;
    margin: 15px;
    justify-content: space-between;
    padding: 0 10px;
    color: #fff;
    font-weight: bold;
    font-size: 22px;
    border: 1px solid #0f4fe3;
    .dian {
      width: 13px;
      height: 13px;
      background: #fff;
      border-radius: 50%;
    }
  }
  .boxtitle {
    justify-content: center;
  }
  .tielesclick {
    background: #fff;
    color: #0f4fe3;
    border: 1px solid #e0e0e0;
    .dian {
      background: #0f4fe3;
    }
  }
  // 交易记录
  .tra {
    width: 319px;
    height: 65px;
    margin: 15px 120px;
  }
  // 表格
  .table {
    // display: flex;
    // justify-content: center;
    padding: 0 300px;
    .send {
      padding: 3px 10px;
      border: 1px solid #fff;
      width: 115px;
      margin: 0 auto;
    }
  }
  // 底部
  .bom {
    padding: 0 150px;
    margin-top: 30px;
    margin: 0 auto;
    display: flex;
    justify-content: center;

    .logos {
      flex-direction: column;
      justify-content: center;
      margin-right: 150px;
      .img1 {
        width: 200px;
        height: 90px;
      }
      .eos {
        font-size: 22px;
        margin: 5px 0;
      }
      .img2 {
        width: 31px;
        height: 31px;
        margin-left: 10px;
      }
      .img3 {
        width: 43px;
        height: 43px;
        margin: 15px 10px;
      }
      .img4 {
        width: 43px;
        height: 33px;
        margin: 15px 10px;
      }
    }
    .item {
      margin: 20px 90px;
      p {
        font-weight: 550;
        font-size: 14px;
        margin: 3px 0;
        cursor: pointer;
      }
    }
    .ban {
      display: flex;
      justify-content: flex-end;
      font-size: 13px;
      margin-right: 200px;
      font-weight: 500;
    }
  }
}
// 弹出层
.tancss {
  width: 160px;
  height: 30px;
  border-radius: 15px;
  background: #0f4fe3;
  margin: 15px;
  justify-content: space-between;
  padding: 0 10px;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  border: 1px solid #0f4fe3;
  .dians {
    width: 10px;
    height: 10px;
    background: #fff;
    border-radius: 50%;
  }
}
.tan {
  .tantop {
    justify-content: space-between;

    .im1 {
      width: 179px;
      height: 33px;
    }
    .im2 {
      width: 87px;
      height: 33.5px;
    }
  }
}
.itemss {
  div {
    margin: 10px 0;
  }
}
/deep/ .el-table {
  margin: 0 auto;
}
/deep/ .el-table__header {
  background: #0f4fe3;
  height: 60px;
}
/deep/ .el-dialog__header {
  padding: 0;
}
/deep/ .el-dialog__body {
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue